import React from 'react';
import bindAll from 'lodash.bindall';
import Draggable from 'react-draggable';
import event, { EVENTS } from '../../lib/event.js';
import Audio from "../../lib/audio.js";
import styles from './style.css';
// import defaultGif from '../../guide/avatar-action/shutup.gif';
import head from '../../guide/avatar-action/head.png';

class XiaoaoEdit extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'onDrag',
            // 'handleStop',
            'handleShowPhoneChat'
        ]);

        this.state = {
            gifUrl: head,
            btnText: props.btnText,
            position: props.position,
        }

        XiaoaoEdit.muteHide = this.muteHide.bind(this);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

   
    onDrag() {
        const div = document.getElementById('xiaoao');
        div.addEventListener("touchmove", function (event) {
            event.preventDefault();
        }, false);
    }

    // handleStop() {
    //     const div = document.getElementsByClassName('react-draggable');
    //     const ele = div[0].style.transform;
    //     const obj = ele.match(/\((.+?)\)/g);
    //     const str = obj[0].replace(/\(|\)/g, '').split(',');
    //     const x = parseInt(str[0]);
    //     const y = parseInt(str[1]);
    //     const boundaryValueX = document.body.clientWidth / 2 + 40;
    //     const boundaryValueY = document.body.clientHeight / 2 - 40

    //     let position;
    //     if (x < -(boundaryValueX) && y > -(boundaryValueY)) {
    //         position = styles.closeLeft
    //     } else if (y < -(boundaryValueY) && x > -(boundaryValueX)) {
    //         position = styles.closeTop
    //     } else if (y < -(boundaryValueY) && x < -(boundaryValueX)) {
    //         position = styles.closeLeftTop
    //     } else {
    //         position = styles.default
    //     }
    //     this.setState({
    //         position: position,
    //         playAudio: false
    //     })
    // }


    handleShowPhoneChat(){
        event.emit(EVENTS.PHONE_CHATBOX);
        window.xiaoaoHide();
    }

    muteHide() {
        this.setState({
            showMute: false
        })
    }

    render() {
        const {
            gifUrl,
            btnText,
            position
        } = this.state

        let positions

        positions = { left: -(document.body.clientWidth - 290), bottom: 0, top: -(document.body.clientHeight - 60), right: 190 }
        
        if(position === 'left'){
            positions = { left: -20, bottom: 0, top: -(document.body.clientHeight - 60), right: (document.body.clientWidth - 140) }
        }

        return (
            <div>
                <Draggable
                    disabled={false}
                    bounds={positions}
                    onDrag={() => this.onDrag()}
                    // onStop={() => this.handleStop()}
                >
                    <div className={`${styles.cartoonBox} ${position === 'left' ? styles.cartoonLeft : styles.cartoonRight}`}>
                        <img className={styles.smallCartoon} src={gifUrl} onContextMenu={() => { return false; }} />
                        {btnText && (<span onClick={()=>this.handleShowPhoneChat()} className={styles.contentBox}>{btnText}</span>)}
                    </div>
                </Draggable>
            </div>
        );
    }
}

export default XiaoaoEdit;
